<template>
  <div class="domain-register">
    <!-- <banner></banner> -->
    <div class="DgrayBg yregister">
      <div class="w1200 flow">
        <h2>域名注册</h2>
        <ul>
          <li>
            <i class="step">1</i>添加清单
          </li>
          <li>
            <i class="step">2</i>确认订单
          </li>
          <li>
            <i>3</i>在线支付
          </li>
          <li>
            <i>4</i>支付成功
          </li>
        </ul>
      </div>
    </div>

    <div class="grayBg yregister" style="padding:20px 0 40px;">
      <div class="reg-tit">
        <dl class="reg-tit1">
          <dt>域名基础服务</dt>
          <dd>注册域名，即可免费享有</dd>
          <p class="yhover-ser1">
            域名自主管理（在线自助实名制、解析设置、dns修改、过户）
            <br />基础版高防DNS服务（防护：10万QPS）
          </p>
        </dl>
        <dl class="reg-tit2">
          <dt>企业服务套餐</dt>
          <dd>
            <i class="green">¥120.00</i>&nbsp;（省¥50.00）
          </dd>
          <p class="yhover-ser2">
            域名自主管理、高级版高防DNS服务（防护：20万PQS）；
            <br />人工服务（3次域名解析设置、1次域名安全锁、1次实名制认证）
          </p>
        </dl>
      </div>
      <div class="reg-tip-text">
        <p>1、备案域名核验数据上报需要3个以上工作日，建议在域名实名认证通过后至少3个工作日再提交网站域名备案</p>
        <p>2、根据CNNIC规定：冠以“中国”、“国家”、“中华”、“全国”字样，且为实体组织的.中国/.CN/.公司/.网络域名，须由对应权益人申请注册，详情请参阅<a target="_blank" href="https://www.300.cn/service/3458.html" style='color:#4dc0b2;'>“常见域名命名审核规定”</a></p>
        <p>3、域名注册时，建议注册信息中域名所有者邮箱尽量不要使用新顶级域名后缀的邮箱，以免订单长时间处理中，错失域名抢注机会等（目前.com/.net/.cn等域名注册信息不支持新顶级域邮箱）</p>
      </div>
      <div class="regtable" v-loading="domainTableIsLoading">
        <table>
          <caption>
            域名信息
            <el-button v-if="!isTrademark" class="fr" type="text" @click="clearInvalidDomain">清空无效域名</el-button>
          </caption>
          <tr>
            <th width="16%">域名</th>
            <th width="6%">类别</th>
            <th width="30%">时长</th>
            <th width="23%">服务</th>
            <th width="19%">费用</th>
            <th width="6%" v-if="!isTrademark">操作</th>
          </tr>
          <tr v-for="(item,i) in cartGroupList" :key="i">
            <td>{{item.domainName}}{{item.domainSuffix}}</td>
            <td>新购</td>
            <td class="year">
              <div
                class="year-pre"
                :class="{disabled:item._yearIndex>=0}"
                @click="item._yearIndex<0&&item._yearIndex++"
              ></div>
              <div class="year-wrap">
                <ul :style="{width:item.allTimeLong.length*50+'px',left:item._yearIndex*50+'px'}">
                  <li
                    :class="{yearCur:n===item.timeLong}"
                    v-for="(n,i) in item.allTimeLong"
                    :key="i"
                    @click="item.timeLong=n,update(item)"
                  >{{i+1}}年</li>
                </ul>
              </div>
              <div
                class="year-next"
                :class="{disabled:item._yearIndex<=-(item.allTimeLong.length-5)}"
                @click="item._yearIndex>-(item.allTimeLong.length-5)&&item._yearIndex--"
              ></div>
            </td>
            <td class="selType">
              <span
                :class="{servCur:serv.id===item.serviceGoodsId}"
                v-for="serv in serviceGoodsList"
                :key="serv.id"
                @click="item.serviceGoodsId=serv.id,update(item)"
              >{{serv.goodsName}}</span>
              <!-- <span>企业服务</span> -->
            </td>
            <td class="cost">
              <!-- {{item}} -->
              <i>¥{{item.sumPrice}}</i>
              <p>
                域名：¥{{item.domainSumPrice}}
                <s>（¥{{item.domainBasePrice}}）</s>
                <br />
                {{item.serviceSumPrice?'域名高级':'基础服务'}}：¥{{item.serviceSumPrice}}
              </p>
            </td>
            <td v-if="!isTrademark" class="delete" @click="del(item)">删除</td>
          </tr>
        </table>
        <div v-if="isTrademark">
          <h2 class="abc">商标注册证书提交</h2>
          <ce-upload
            @success="uploadSuccess"
            limit="999"
            placeholder="支持55KB~1M以内 .jpg、.png、.rar、.zip格式文件上传"
          ></ce-upload>
        </div>
      </div>
      <div class="regban">
        <h2>选择域名注册模板</h2>

        <section>
          <p style="line-height:20px;margin-bottom:10px;">域名注册重要提示：<br />自2022年1月1日起，域名注册严格执行《中华人民共和国网络安全法》和《互联网域名管理办法》关于身份信息核验的管理规定，完成身份信息核验（域名模板通过实名认证审核）后，再进行域名的注册。</p>
          <p style="line-height:20px;">域名注册流程：<br />
① 使用已通过实名认证审核的域名注册模板：在下方列表中选择模板后直接下单进行注册（未通过实名认证审核的模板不可选择）；<br />
② 域名注册模板未通过实名认证审核：<a class="green" href="https://new-console.300.cn/domainCenter/template/list/1" target="_blank" rel="noopener noreferrer">提交实名认证审核</a> 或 <a class="green" href="https://new-console-domain.300.cn/domainCenter/template/template/editInfo" target="_blank" rel="noopener noreferrer">使用新的域名注册模板并提交实名认证审核</a> ；<br />
③ 域名注册模板实名认证审核预计需要1~3个工作日，审核通过后，可 <a href="javascript:;" onclick="location.reload()">刷新</a> 本页面，支付订单后完成域名注册。</p>
          <div class="selban">
            <label
              v-for="(item,i) in templateList"
              :key="i"
              :class="{user:item.registrantType==='I'}"
            >
              <input type="radio" :value="item.id" v-model="domainTemplateId" />
              {{item.templateName}}
              <em>{{item.registrantTypeLabel}}注册信息</em>

              <el-button type="text" @click="item.dialogVisible = true">详情</el-button>

              <el-dialog title="域名模板详情" :visible.sync="item.dialogVisible" width="40%">
                <span class="dgcon-list">
                  <p>
                    <i>模板名称</i>
                    <b>{{item.templateName}}</b>
                  </p>
                  <p>
                    <i>所有者类型</i>
                    <b>{{item.apiType}}</b>
                  </p>
                  <p>
                    <i>域名所有者(中文)</i>
                    <b>{{item.nameCn}}</b>
                  </p>
                  <p>
                    <i>域名所有者(英文)</i>
                    <b>{{item.nameEn}}</b>
                  </p>
                  <p>
                    <i>资料认证状态</i>
                    <b>{{item.status}}</b>
                  </p>
                  <p>
                    <i>域名联系人(中文)</i>
                    <b>{{item.custLinkmanCn}}</b>
                  </p>
                  <p>
                    <i>域名联系人(英文)</i>
                    <b>{{item.custLinkmanEn}}</b>
                  </p>
                  <p>
                    <i>所属区域</i>
                    <b></b>
                  </p>
                  <p>
                    <i>省份(英文)</i>
                    <b>{{item.provinceEn}}</b>
                  </p>
                  <p>
                    <i>城市(英文)</i>
                    <b>{{item.cityEn}}</b>
                  </p>
                  <p>
                    <i>通讯地址(中文)</i>
                    <b>{{item.addressCn}}</b>
                  </p>
                  <p>
                    <i>通讯地址(英文)</i>
                    <b>{{item.addressEn}}</b>
                  </p>
                  <p>
                    <i>邮政编码</i>
                    <b>{{item.zipCode}}</b>
                  </p>
                  <p>
                    <i>电话</i>
                    <b>{{item.tel}}</b>
                  </p>
                  <p>
                    <i>手机号码</i>
                    <b>{{item.cellPhoneNumber}}</b>
                  </p>
                  <p>
                    <i>电子邮箱</i>
                    <b>{{item.email}}</b>
                  </p>
                </span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="item.dialogVisible = false">关闭</el-button>
                </span>
              </el-dialog>
            </label>
            <div class="add-new-template" v-if="isTrademark">
              <el-button class="green" type="text" @click="gotoTemplate">创建新的域名信息模板</el-button>
            </div>
            <!-- <label v-else>
              <input type="radio" value="newDomainInfo" v-model="domainTemplateId" />使用新的域名注册信息
            </label>
            <dl class="regnewinfo" v-if="domainTemplateId==='newDomainInfo'&& !isTrademark">
              <dt class="clearfix">
                <b>所有者类型：</b>
                <div class="selType2 fl">
                  <span
                    @click="form.registrantType='I'"
                    :class="{selCur:form.registrantType==='I'}"
                  >个人用户</span>
                  <span
                    @click="form.registrantType='E'"
                    :class="{selCur:form.registrantType==='E'}"
                  >企业用户</span>
                </div>
                <a class="howsel fl">如何选择？</a>
                <section class="fl">使用已实名的信息模板便于您注册域名后快速实名认证可在信息模板中创建和管理。</section>
              </dt>
              <dd>
                <b>域名所有者（中文）：</b>
                <div>
                  <input v-model="form.nameCn" type="text" />
                </div>
              </dd>
              <dd>
                <b>域名所有者（英文）：</b>
                <div>
                  <input v-model="form.nameEn" type="text" />
                </div>
              </dd>
              <dd>
                <b>电子邮箱：</b>
                <div>
                  <input v-model="form.email" type="text" />
                </div>
              </dd>
              <dd>
                <b></b>
                <div class="save">
                  <button class="nextCur" @click="saveTemplate">保存模板</button>
                </div>
              </dd>
            </dl> -->
          </div>
          <div class="agree">
            <!-- <p>人工服务
              <label><input type="checkbox" name="b">下单后，立即为购买【企业服务】的域名提供人工实名制服务</label>
            </p>-->
            <protocol-domain @input="changeChecked" :acceptAgreement="acceptAgreement"></protocol-domain>
          </div>
        </section>
      </div>
      <div class="total">
        <p>
          总价费用：
          <i>￥{{cartInfoVO&&cartInfoVO.deaiMoney}}</i>
        </p>
        <button @click="$router.go(-1)">上一步</button>
        <el-button
          :loading="nextButtonIsLoading"
          :disabled="cartInfoVO&&cartInfoVO.deaiMoney==='--'"
          style="padding:0;border-radius:0"
          :class="{nextCur:acceptAgreement}"
          @click="save"
        >下一步</el-button>
      </div>
    </div>
    <el-dialog
      :visible.sync="visibleCertificate"
      class="trademark-dialog"
      title
      width="550px"
      size="small"
    >
      <div slot="title" class="f14">提示</div>
      <div class="fix">
        <img src="../static/assets/tip.png" style="width:35px;" class="fl pl10 mr20" />
        <div class="fl" style="width:430px;">
          <div class="dialog-title f12 c3 bold">您是否持有商标注册证书？</div>
          <div class="dialog-body c6 mt10 mb10">
            <div class="f12">
              .商标申请人必须与商标持有者保持一致，否则购买后不能通过注册审核。
              <br />.商标提交资料后，注册局可能会就商标资质审核问题与您联系
            </div>
          </div>
        </div>
      </div>
      <div class="tc mt20">
        <el-button
          size="small"
          @click="buyTrademark"
          class="ce-primary-btn"
          type="primary"
        >我持有商标注册证书，继续购买.商标域名</el-button>
        <el-button size="small" @click="gotoTrademark">前往商标服务</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import banner from "./components/header";
import ceUpload from "./components/ce-upload";
import recommend from "./components/recommend";
import cTitle from "./components/title";
import protocolDomain from "./components/Protocol-domain";

export default {
  data() {
    return {
      isTrademark: this.$route.query.item ? true : false,
      trademarkInfo: {},
      cartGroupDetailVo: {
        basePrice: "",
        domainName: "",
        domainSuffix: "",
        goodsCode: "",
        goodsId: "",
        productNum: "",
        productNumName: "",
        productNumUnit: "",
        skuCode: "",
        skuId: "",
        skuName: "",
        timeLong: "",
        TIME_LONG: "",
        timeLongName: "",
        timeLongUnit: "",
        domainAttachment: ""
      },
      visibleCertificate: false,
      initData: [],
      nextButtonIsLoading: false,
      domainTableIsLoading: false,
      isAcceptDomainTreaty: false,
      cartInfoVO: null,
      serviceGoodsList: [],
      cartGroupList: [],
      templateList: [],
      domainTemplateId: "",
      isShowTemplateForm: false,
      acceptAgreement: true,
      form: {
        registrantType: "E",
        nameCn: "",
        nameEn: "",
        email: "",
        source: "3"
      }
    };
  },
  components: {
    banner,
    recommend,
    cTitle,
    protocolDomain,
    ceUpload
  },
  methods: {
    buyTrademark() {
      this.visibleCertificate = false;
    },
    gotoTrademark() {
      window.location.href = "https://www.300.cn/trademark";
    },
    clearInvalidDomain() {
      for (let i = 0; i < this.cartGroupList.length; i++) {
        if (this.cartGroupList[i].domainRegister !== 1) {
          this.cartGroupList.splice(i, 1);
          this.clearInvalidDomain();
          return;
        }
      }

      this.update();
    },
    changeChecked(v) {
      this.acceptAgreement = v;
    },
    del(item) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          for (let i = 0; i < this.cartGroupList.length; i++) {
            if (this.cartGroupList[i].cartGroupId === item.cartGroupId) {
              this.cartGroupList.splice(i, 1);
              this.update();
              return;
            }
          }
        })
        .catch(() => {});
    },
    uploadSuccess(val) {
      this.cartGroupDetailVo.domainAttachment = val.id;
    },
    update(item) {
      if (item) {
        item.sumPrice = "--";
      }
      if (this.isTrademark) {
        this.updateTrademark();
        return;
      }
      this.cartInfoVO.deaiMoney = "--";
      const cartGroupList = this.cartGroupList.map(v => {
        return {
          cartGroupId: v.cartGroupId,
          cartGroupInfo: {
            TIME_LONG: v.timeLong,
            serviceGoodsId: v.serviceGoodsId
          }
        };
      });

      const data = {
        cartInfoId: this.cartInfoVO.id,
        cartGroupList,
        domainTemplateId: this.domainTemplateId
      };
      this.domainTableIsLoading = true;
      $.post(`${__shopURL}/order/updatecartinfo`, {
        data: JSON.stringify(data)
      }).then(
        response => {
          this.domainTableIsLoading = false;
          this.initCartsList(response, "update");
          return;

          this.cartInfoVO.deaiMoney = response.cartInfoVO.deaiMoney;
          response.cartInfoVO.cartGroupVOList.forEach(v => {
            const cur = this.cartGroupList.filter(
              c => c.cartGroupId === v.id
            )[0];
            if (cur) {
              cur.sumPrice = v.sumPrice;
            }
          });
        },
        error => {
          this.domainTableIsLoading = false;
          this.$msgbox({
            type: "error",
            message: "服务器忙！请稍后再试！"
          });
        }
      );
    },
    updateTrademark() {
      let postData = this.getPostInfo();
      this.domainTableIsLoading = true;
      $.post(`${__shopURL}/order/updateDomainCartsTrademark`, {
        data: JSON.stringify(postData)
      }).then(response => {
        this.domainTableIsLoading = false;
        this.initCartsList(response);
      });
    },
    save() {
      if (!this.acceptAgreement) {
        // this.$msgbox({
        //   // title:'',
        //   type: "error",
        //   message: "请先同意《中企动力域名注册服务协议》"
        // });
        this.$message.error("请先同意《中企动力域名注册服务协议》");
        return;
      }

      if (!this.cartGroupList || this.cartGroupList.length === 0) {
        this.$msgbox({
          type: "error",
          message: "没有选中任何域名！"
        });
        return;
      }

      if (!this.domainTemplateId || this.domainTemplateId === "newDomainInfo") {
        this.$msgbox({
          type: "error",
          message: "没有选中任何域名模板！"
        });
        return;
      }

      const cartGroupList = this.cartGroupList.map(v => {
        return {
          cartGroupId: v.cartGroupId,
          cartGroupInfo: {
            TIME_LONG: v.timeLong,
            serviceGoodsId: v.serviceGoodsId
          }
        };
      });

      const data = {
        cartInfoId: this.cartInfoVO.id,
        cartGroupList,
        domainTemplateId: this.domainTemplateId
      };

      if (this.isTrademark) {
        if (this.cartGroupDetailVo.domainAttachment == "") {
          this.$message({
            type: "error",
            message: "请上传商标注册证书"
          });
          return;
        }
        let postData = this.getPostInfo();
        this.nextButtonIsLoading = true;
        $.post(`${__shopURL}/order/savedomainorderTrademark`, {
          data: JSON.stringify(postData)
        }).then(response => {
          this.nextButtonIsLoading = false;
          if (!response || !response.orderid) {
            this.$message({
              type: "error",
              message: response.msg || "错误"
            });
            return;
          }
          window.location.href =
            window.location.protocol +
            "//" +
            window.location.host +
            `/payment/index.html?orderid=${response.orderid}`;
        });
      } else {
        this.nextButtonIsLoading = true;
        $.post(`${__shopURL}/order/savedomainorder`, {
          data: JSON.stringify(data)
        }).then(response => {
          this.nextButtonIsLoading = false;
          if (!response || !response.orderid) {
            this.$message({
              type: "error",
              message: response.msg || "错误"
            });
            return;
          }

          window.location.href =
            window.location.protocol +
            "//" +
            window.location.host +
            `/payment/index.html?orderid=${response.orderid}`;
        });
      }

      //
    },
    gotoTemplate() {
      window.open("http://new-console.300.cn/domainCenter/template/list/1");
    },
    saveTemplate() {
      $.post(`/security/domainTemplate/addForOrder`, {
        data: JSON.stringify({ domainTemplateVo: this.form })
      }).then(response => {
        if (response && response.status) {
          this.$message({
            type: "error",
            message: response.msg
          });
          return;
        }
        response.domainTemplateVo.dialogVisible = false;
        this.templateList.push(response.domainTemplateVo);
        this.domainTemplateId = response.domainTemplateVo.id;
      });
    },
    getDomainTemplateList() {
      let post = { pageSize: 999, status: 'C' };
      if (this.isTrademark) {
        post.trademark = "trademark";
      }
      $.get(`/security/domainTemplate/list`, post).then(response => {
        let domainTemplateList = response.domainTemplateList
          ? response.domainTemplateList
          : [];
        this.templateList = domainTemplateList.map(v => {
          v.dialogVisible = false;
          return v;
        });
        this.domainTemplateId =
          (this.templateList[0] && this.templateList[0].id) || "newDomainInfo";
      });
    },
    getDomainCartsList() {
      this.domainTableIsLoading = true;
      $.get("/order/domaincartslist").then(
        response => {
          this.initCartsList(response);

          this.domainTableIsLoading = false;
        },
        error => {
          this.domainTableIsLoading = false;
          this.$msgbox({
            type: "error",
            message: "服务器忙！请稍后再试！"
          });
        }
      );
    },
    initCartsList(response, type) {
      this.cartGroupList =
        response.cartInfoVO &&
        response.cartInfoVO.cartGroupVOList.map(v => {
          const domainRegister = v.cartGroupDetailVOList[0].domainRegister;
          const timeLongAttr = v.cartGroupDetailVOList[0].cartDetailAttrVOList.filter(
            v => v.attrCode === "TIME_LONG"
          )[0];
          let allTimeLong = [];
          let _yearIndex = 0;
          if (type === "update") {
            _yearIndex = this.cartGroupList.filter(
              c => c.cartGroupId === v.id
            )[0]._yearIndex;
          }

          if (timeLongAttr) {
            const { minValue, maxValue, stepValue, attrCode } = timeLongAttr;
            let i = minValue;
            while (i <= maxValue) {
              allTimeLong.push(i);
              i = i + stepValue;
            }
          }
          return {
            _yearIndex,
            domainName: v.cartGroupDetailVOList[0].domainName,
            domainSuffix: v.cartGroupDetailVOList[0].domainSuffix,
            sumPrice: v.sumPrice,
            domainSumPrice: v.cartGroupDetailVOList[0].sumPrice,
            domainBasePrice: v.cartGroupDetailVOList[0].basePrice,
            serviceSumPrice: v.cartGroupDetailVOList[1].sumPrice,
            cartGroupId: v.id,
            allTimeLong,
            domainRegister,
            timeLong: v.cartGroupDetailVOList[1].timeLong,
            serviceGoodsId: v.cartGroupDetailVOList[1].goodsId
          };
        });

      // if (type === 'update') {
      //   console.log(this.cartInfoVO)
      //   this.cartInfoVO.sumPrice = response.sumPrice
      //   this.cartInfoVO.domainSumPrice = response.domainSumPrice
      //   this.cartInfoVO.domainBasePrice = response.domainBasePrice
      //   this.cartInfoVO.serviceSumPrice = response.serviceSumPrice
      //   this.cartInfoVO.deaiMone = response.cartInfoVO.deaiMoney
      //   return
      // }

      this.cartInfoVO = response.cartInfoVO;
      this.serviceGoodsList = response.serviceGoodsList;
      // this.cartGroupVOList = response.cartInfoVO.cartGroupVOList
    },
    getTrademarkInfo() {
      $.get("/dcarts/ditialDomainCartsfictitious", {
        data: JSON.stringify([JSON.parse(this.$route.query.item)])
      }).then(res => {
        this.trademarkInfo = res.cartInfoVO;
        this.initCartsList(res);
        this.domainTableIsLoading = false;
      });
    },
    getPostInfo() {
      let po = {
        cartGroupVOList: [
          {
            domainName: this.trademarkInfo.cartGroupVOList[0]
              .cartGroupDetailVOList[0]["domainName"],
            domainSuffix: this.trademarkInfo.cartGroupVOList[0]
              .cartGroupDetailVOList[0]["domainSuffix"],
            TIME_LONG: this.cartGroupList[0].timeLong,
            serviceGoodsId: this.cartGroupList[0].serviceGoodsId,
            domainAttachment: this.cartGroupDetailVo.domainAttachment
          }
        ],
        domainTemplateId: this.domainTemplateId
      };
      return po;
    }
  },

  created() {
    if (this.isTrademark) {
      this.domainTemplateId = "isTrademark";

      this.visibleCertificate = true;
      this.getTrademarkInfo();
    } else {
      this.getDomainCartsList();
    }
    this.getDomainTemplateList();

    // 清除购物车缓存
    window.localStorage.removeItem("cartList");
  }
};
</script>

<style  lang="scss">
@import "../static/css/register.scss";
</style>



// WEBPACK FOOTER //
// src/register.vue